document.addEventListener('DOMContentLoaded', function () {
  const hotspots = document.querySelectorAll('.shop-the-look-hotspot');
  const productCards = document.querySelectorAll('.shop-the-look-product-card');
  const imageContainer = document.getElementById('shopTheLookImage');
  const isDevMode = window.location.search.includes('hotspot-edit=1') || (window.Shopify && window.Shopify.designMode);

  function getVisibleHotspotsAndCards() {
    // Use mobile view for screens 989px and below (iPad portrait & phones), desktop view for 990px and above (iPad landscape & desktop)
    const isMobile = window.innerWidth <= 989;
    let visibleHotspots, visibleCards;
    if (isMobile) {
      visibleHotspots = Array.from(document.querySelectorAll('.shop-the-look-hotspot-mobile'));
      visibleCards = Array.from(document.querySelectorAll('.shop-the-look-product-card-wrapper-mobile .shop-the-look-product-card'));
    } else {
      visibleHotspots = Array.from(document.querySelectorAll('.shop-the-look-hotspot-desktop'));
      visibleCards = Array.from(document.querySelectorAll('.shop-the-look-product-card-wrapper-desktop .shop-the-look-product-card'));
    }
    return { visibleHotspots, visibleCards };
  }

  /**
   * @param {HTMLElement[]} visibleHotspots
   * @param {HTMLElement[]} visibleCards
   */
  function clearActive(visibleHotspots, visibleCards) {
    visibleHotspots.forEach(function(h) { h.classList.remove('active'); });
    visibleCards.forEach(function(p) { p.classList.remove('active'); });
  }

  function setupHotspotActivation() {
    var obj = getVisibleHotspotsAndCards();
    var visibleHotspots = obj.visibleHotspots;
    var visibleCards = obj.visibleCards;
    if (visibleHotspots.length === 0) {
      visibleCards.forEach(function(card) {
        card.classList.remove('active');
      });
      return;
    }
    visibleHotspots.forEach(function(hotspot) {
      hotspot.addEventListener('click', function () {
        visibleHotspots.forEach(function(h) { h.classList.remove('active'); });
        visibleCards.forEach(function(c) { c.classList.remove('active'); });
        hotspot.classList.add('active');
        var id = hotspot.getAttribute('data-product-id');
        if (id) {
          visibleCards.forEach(function(card) {
            if (card.getAttribute('data-product-id') === id) {
              card.classList.add('active');
              var slider = card.querySelector('card-slider');
              if (slider && typeof slider.updateButtons === 'function') {
                requestAnimationFrame(function() { slider.updateButtons(); });
              }
            }
          });
        }
      });
      hotspot.addEventListener('keypress', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          visibleHotspots.forEach(function(h) { h.classList.remove('active'); });
          visibleCards.forEach(function(c) { c.classList.remove('active'); });
          hotspot.classList.add('active');
          var id = hotspot.getAttribute('data-product-id');
          if (id) {
            visibleCards.forEach(function(card) {
              if (card.getAttribute('data-product-id') === id) {
                card.classList.add('active');
                var slider = card.querySelector('card-slider');
                if (slider && typeof slider.updateButtons === 'function') {
                  requestAnimationFrame(function() { slider.updateButtons(); });
                }
              }
            });
          }
        }
      });
    });
    // Activate the first hotspot and card by default
    if (visibleHotspots[0]) {
      visibleHotspots[0].classList.add('active');
      var id = visibleHotspots[0].getAttribute('data-product-id');
      if (id) {
        visibleCards.forEach(function(card) {
          if (card.getAttribute('data-product-id') === id) {
            card.classList.add('active');
            var slider = card.querySelector('card-slider');
            if (slider && typeof slider.updateButtons === 'function') {
              requestAnimationFrame(function() { slider.updateButtons(); });
            }
          }
        });
      }
    }
  }

  // Initial setup
  setupHotspotActivation();
  // Re-setup on resize (to handle switching between mobile/desktop)
  window.addEventListener('resize', function() {
    setupHotspotActivation();
  });

  // Developer drag-and-drop mode for hotspot positioning
  if (isDevMode && imageContainer) {
    // Create a floating panel for X/Y values
    let floatingPanel = document.createElement('div');
    floatingPanel.style.position = 'fixed';
    floatingPanel.style.top = '20px';
    floatingPanel.style.right = '20px';
    floatingPanel.style.background = '#222';
    floatingPanel.style.color = '#fff';
    floatingPanel.style.padding = '10px 16px';
    floatingPanel.style.borderRadius = '8px';
    floatingPanel.style.fontSize = '16px';
    floatingPanel.style.zIndex = '9999';
    floatingPanel.style.display = 'none';
    floatingPanel.style.boxShadow = '0 2px 8px rgba(0,0,0,0.2)';
    floatingPanel.textContent = '';
    document.body.appendChild(floatingPanel);

    hotspots.forEach(function(hotspot, i) {
      /** @type {HTMLElement} */
      var hotspotEl = /** @type {HTMLElement} */(hotspot);
      hotspotEl.style.cursor = 'grab';
      let offsetX = 0, offsetY = 0, dragging = false;
      let tooltip = hotspotEl.querySelector('.hotspot-tooltip');
      if (!tooltip) {
        tooltip = document.createElement('span');
        tooltip.className = 'hotspot-tooltip';
        hotspotEl.appendChild(tooltip);
      }
      hotspotEl.addEventListener('mousedown', function(e) {
        dragging = true;
        offsetX = /** @type {MouseEvent} */(e).offsetX;
        offsetY = /** @type {MouseEvent} */(e).offsetY;
        hotspotEl.style.zIndex = '1000';
        document.body.style.userSelect = 'none';
        floatingPanel.style.display = 'block';
      });
      document.addEventListener('mousemove', function(e) {
        if (!dragging) return;
        const rect = imageContainer.getBoundingClientRect();
        let x = ((/** @type {MouseEvent} */(e)).clientX - rect.left - offsetX) / rect.width * 100;
        let y = ((/** @type {MouseEvent} */(e)).clientY - rect.top - offsetY) / rect.height * 100;
        x = Math.max(0, Math.min(100, x));
        y = Math.max(0, Math.min(100, y));
        hotspotEl.style.left = x + '%';
        hotspotEl.style.top = y + '%';
        tooltip.style.display = 'block';
        tooltip.textContent = `X: ${x.toFixed(1)}% | Y: ${y.toFixed(1)}%`;
        floatingPanel.textContent = `Hotspot #${i+1}: X: ${x.toFixed(1)}% | Y: ${y.toFixed(1)}%`;
      });
      document.addEventListener('mouseup', function() {
        if (dragging) {
          dragging = false;
          hotspotEl.style.zIndex = '';
          document.body.style.userSelect = '';
          floatingPanel.style.display = 'none';
        }
      });
    });
  }

  function matchShopTheLookHeights() {
    var imageContainer = document.querySelector('.shop-the-look-image');
    var productsContainer = document.querySelector('.shop-the-look-products');
    if (!imageContainer || !productsContainer) return;
    // Reset height first
    var productsContainerEl = /** @type {HTMLElement} */(productsContainer);
    var imageContainerEl = /** @type {HTMLElement} */(imageContainer);
    productsContainerEl.style.height = '';
    var image = imageContainerEl.querySelector('img');
    if (image && image.complete) {
      productsContainerEl.style.height = imageContainerEl.offsetHeight + 'px';
    } else if (image) {
      image.addEventListener('load', function() {
        productsContainerEl.style.height = imageContainerEl.offsetHeight + 'px';
      }, { once: true });
    }
  }

  // --- Mobile Hotspot Position/Radius Logic ---
  function applyMobileHotspotStyles() {
    // Use mobile view for screens 989px and below (iPad portrait & phones), desktop view for 990px and above (iPad landscape & desktop)
    const isMobile = window.innerWidth <= 989;
    hotspots.forEach(hotspot => {
      // Get desktop values from inline style
      const desktopTop = hotspot.style.top;
      const desktopLeft = hotspot.style.left;
      const desktopWidth = hotspot.style.width;
      const desktopHeight = hotspot.style.height;
      // Get mobile data attributes
      const mobileX = hotspot.getAttribute('data-mobile-x');
      const mobileY = hotspot.getAttribute('data-mobile-y');
      const mobileRadius = hotspot.getAttribute('data-mobile-radius');
      if (isMobile && (mobileX || mobileY || mobileRadius)) {
        // Use mobile values if set, fallback to desktop if not
        hotspot.style.left = (mobileX && mobileX !== 'null') ? mobileX + '%' : desktopLeft;
        hotspot.style.top = (mobileY && mobileY !== 'null') ? mobileY + '%' : desktopTop;
        const radius = (mobileRadius && mobileRadius !== 'null') ? mobileRadius + 'px' : desktopWidth;
        hotspot.style.width = radius;
        hotspot.style.height = radius;
      } else {
        // Revert to desktop values
        hotspot.style.left = desktopLeft;
        hotspot.style.top = desktopTop;
        hotspot.style.width = desktopWidth;
        hotspot.style.height = desktopHeight;
      }
    });
  }

  applyMobileHotspotStyles();
  window.addEventListener('resize', applyMobileHotspotStyles);
  // Also listen for orientation changes to handle iPad rotation
  window.addEventListener('orientationchange', function() {
    // Small delay to ensure the viewport has updated
    setTimeout(function() {
      applyMobileHotspotStyles();
      setupHotspotActivation();
      matchShopTheLookHeights();
    }, 100);
  });

  matchShopTheLookHeights();
  window.addEventListener('resize', matchShopTheLookHeights);
}); 